/*
 * Author: Chao.Wang
 * File Created: Thursday, 25-01-09 04:05 pm
 * Last Modified: Friday, 25-03-07 04:59 pm, by Ben Zhao
 */

import { graphql } from '@web/graphql';

import type { AGREEMENT_TYPE, GraphqlAgreementInfo } from '@/@types/agreement';

const queryAgreementByType = graphql.gql`
  query DeCardAgreementAlls(
    $filters: DeCardAgreementAllFiltersInput
    $sort: [String]
    $status: PublicationStatus
  ) {
    deCardAgreementAlls(filters: $filters, sort: $sort, status: $status) {
      version
      link
      pdf {
        url
      }
      de_card_agreement_type {
        type
      }
      updatedAt
    }
  }
`;

export const getAgreement = async (
  payload: {
    type: AGREEMENT_TYPE;
    version?: string;
  },
  config?: { force?: boolean },
) => {
  const { data } = await graphql.query<{
    deCardAgreementAlls?: GraphqlAgreementInfo[];
  }>(queryAgreementByType, {
    variables: {
      filters: {
        de_card_agreement_type: {
          type: {
            eq: payload.type,
          },
        },
        version: {
          contains: payload.version || '',
        },
      },
      sort: ['updatedAt:desc'],
    },
    force: config?.force,
  });

  const agreementInfo = data.deCardAgreementAlls?.map((agreement) => ({
    type: agreement.de_card_agreement_type.type,
    url: agreement.pdf?.url ?? agreement.link,
    version: agreement.version,
  }));

  if (payload.version) {
    agreementInfo;
  } else {
    return agreementInfo?.[0];
  }
};
